<template>
  <b-container fluid="xl" class="header-nav">
    <router-link to="/">
      <img class="logo" src="../assets/logo-pc.png" alt="logo"/>
    </router-link>

    <ul class="nav-bar">
      <li class="nav-item" v-for="item in menus" :key="item.name">
        <router-link :to="item.path" active-class="nav-item-label active-menu" class="nav-item-label">
          <span v-t="item.name" :id="item.name"></span>
        </router-link>
        <b-popover :target="item.name" triggers="hover" placement="bottom" custom-class="submenu">
          <ul class="submenu-list" v-if="item.children">
            <li
              v-for="submenu in item.children"
              :key="submenu.name"
            >
              <router-link :to="submenu.path" active-class="active-submenu submenu-item" class="submenu-item" @click="submenuClick(item.path)">
                <span v-t="submenu.name"></span>
              </router-link>
            </li>
          </ul>
        </b-popover>
      </li>
<!--      <li class="nav-item">-->
<!--        <b-popover target="lang-item" triggers="hover" placement="bottom" custom-class="lang-selector">-->
<!--          <ul class="lang-list">-->
<!--            <li-->
<!--              v-for="(item, index) in langList"-->
<!--              :key="item.value"-->
<!--              :class="{active: index === activeLang}"-->
<!--              @click="onLangSelected(index)"-->
<!--            >-->
<!--              {{item.label}}-->
<!--            </li>-->
<!--          </ul>-->
<!--        </b-popover>-->
<!--        <span id="lang-item" class="lang-item">-->
<!--            {{langList[activeLang].label}}-->
<!--          </span>-->
<!--      </li>-->
    </ul>
  </b-container>
</template>

<script>
import menus from './menus'
export default {
  name: 'NavBar-pc',
  data () {
    return {
      activeLang: 0,
      langList: [
        {
          label: '简',
          value: 'zh-CN'
        }
        // {
        //   label: 'ENG',
        //   value: 'en-US'
        // }
        // {
        //   label: '繁',
        //   value: 'zh-CN-HK'
        // }
      ],
      menus
    }
  },
  methods: {
    onLangSelected (index) {
      this.activeLang = index
      this.$i18n.locale = this.langList[index].value
    },
    submenuClick (path) {
      console.log(path)
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss">
  .submenu, .lang-selector {
    .popover-body {
      padding: 10px 0 !important;
    }
  }
</style>
<style scoped lang="scss">
  .header-nav {
    display: flex;

    .logo {
      width: 206px;
    }

    ul.nav-bar {
      flex: 1;
      padding: 0;
      margin: 0;
      white-space: nowrap;
      line-height: 54px;
      text-align: right;

      .active-menu {
        text-decoration: underline;
      }

      li.nav-item {
        list-style: none;
        display: inline-block;
        margin-left: 35px;
        font-size: 12px;
        font-weight: 700;
        color: #ffffff;
        cursor: pointer;
        border-bottom: 1px solid transparent;

        .nav-item-label {
          color: #ffffff;
        }
      }

      .lang-item {
        display: inline-block;
        width: 25px;
      }
    }
  }

  .submenu-list {
    .submenu-item {
      color: #000000;
    }
  }

  ul.submenu-list {
    padding: 0;
    margin: 0;

    .active-submenu {
      text-decoration: underline;
    }

    li {
      text-align: center;
      line-height: 30px;
      list-style: none;
      padding: 0 10px;

      &:hover, &.active {
        background-color: #eeeeee;
      }

      & + li {
        border-top: 1px solid #eeeeee;
      }
    }
  }

  ul.lang-list {
    padding: 0;
    margin: 0;

    li {
      list-style: none;
      line-height: 35px;
      width: 80px;
      text-align: center;
      cursor: pointer;

      &:hover, &.active {
        background-color: #eeeeee;
      }

      & + li {
        border-top: 1px solid #eeeeee;
      }
    }
  }
</style>
